//设置alert显示
export const SET_ALERT_SHOW = 'SET_ALERT_SHOW';
//设置alert隐藏
export const SET_ALERT_HIDE = 'SET_ALERT_HIDE';
//设置alert数据
export const SET_ALERT_DATA = 'SET_ALERT_DATA';


//设置confirm显示
export const SET_CONFIRM_SHOW = 'SET_CONFIRM_SHOW';
//设置confirm隐藏
export const SET_CONFIRM_HIDE = 'SET_CONFIRM_HIDE';
//设置confirm数据
export const SET_CONFIRM_DATA = 'SET_CONFIRM_DATA';


//设置titleConfirm显示
export const SET_TITLE_CONFIRM_SHOW = 'SET_TITLE_CONFIRM_SHOW';
//设置titleConfirm隐藏
export const SET_TITLE_CONFIRM_HIDE = 'SET_TITLE_CONFIRM_HIDE';
//设置titleConfirm数据
export const SET_TITLE_CONFIRM_DATA = 'SET_TITLE_CONFIRM_DATA';

//隐藏底部注册提示
export const SET_HIDE_REGISTER_TIP = 'SET_HIDE_REGISTER_TIP';
//显示底部注册提示
export const SET_SHOW_REGISTER_TIP = 'SET_SHOW_REGISTER_TIP';

//设置第三方登录中间页upk
export const SET_MIXINTRANSFER_UPK = 'SET_MIXINTRANSFER_UPK';

//设置百度第三方登录中间页bindTokenSign
export const SET_BAIDU_BINDTOKENSIGN = 'SET_BAIDU_BINDTOKENSIGN';



// WEBPACK FOOTER //
// ./src/store/mutation_types.js